<template>
  <div>
    <div class="nav-pagination">
      <div class="container">
        <hr class="hraing" />
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="sooper-text">
              <h4>Data Management</h4>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 text-right nav-pagination1">
            <ul>
              <li>
                <a href="index.html">Services</a>
              </li>
              <li>|</li>
              <li>Data Management</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <section class="discover-analytics">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-sm-6">
            <div class="right-text wow animated slideInLeft">
              <h1>Data Management</h1>
              <h4>The data you need at your fingertips</h4>
              <p>Covering all your data management needs. Cleansing datasets, managing databases or building bespoke transformation pipelines. We give access to insights when you need them, without the headache.</p>
              <div class="button-center">
                <a href class="btn button3">Find Out More</a>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-6">
            <div class="wow animated zoomIn">
              <img
                src="../image/Vectors/Web-DeveloperDAC.svg"
                class="img-responsive img-services-vector"
                alt="desktop"
              />
            </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <div class="wow animated zoomIn">
              <br />
              <br />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2">
            <div class="wow animated zoomIn">
              <center>
                <img
                  src="../image/Icons/Laptop feeding data.png"
                  class="img-responsive img-service-page"
                  alt="desktop"
                />
              </center>
            </div>
          </div>
          <div class="col-md-4">
            <div class="right-text wow animated slideInLeft">
              <h4>Advanced Data Modelling</h4>
              <p>Proper data management creates time saving across organisations. We turn your data into high performance models, creating the perfect platform to begin leveraging data into insights.</p>
            </div>
          </div>
          <div class="col-md-2">
            <div class="wow animated zoomIn">
              <center>
                <img
                  src="../image/Icons/Easy-ops.png"
                  class="img-responsive img-service-page"
                  alt="desktop"
                />
              </center>
            </div>
          </div>
          <div class="col-md-4">
            <div class="right-text wow animated slideInLeft">
              <h4>Straight-forward operations</h4>
              <p>Carefully designed data management will also make regulatory compliance, infrastructure setup and many other operational tasks easier for everyone involved.</p>
            </div>
          </div>
        </div>
        <br />
        <hr />
        <br />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInLeft">
                <div class="img-datacol"></div>
                <h4>Data Collection</h4>
                <p>Designing and developing solutions; gathering data from any source.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInUp">
                <div class="img-ware"></div>
                <h4>Data Warehousing</h4>
                <p>Organise and store data in high speed data warehouses.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInRight">
                <div class="img-man"></div>
                <h4>Database Management</h4>
                <p>Gain control over data for easy governance and efficient workflows.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInLeft">
                <div class="img-transform"></div>
                <h4>ETL Pipelines</h4>
                <p>Move and transform your data to where it is needed most.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>

          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInUp">
                <div class="img-manage"></div>
                <h4>Infrastructure Monitoring</h4>
                <p>Manage your resources effectively and optimize continuously.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>

          <div class="col-md-4 col-sm-6">
            <router-link to="/Contact">
              <div class="feature-text text-center wow animated slideInRight">
                <div class="img-clean"></div>
                <h4>Data Cleansing</h4>
                <p>Sort, Clean and Mine data to make analysis more reliable.</p>
                <a>Get Started</a>
              </div>
            </router-link>
          </div>
          <div class="col-md-12 no-padding">
            <div class="heading text-center">
              <br />
              <h3>What our customers think about</h3>
              <br />
              <h3>Discovr Analytics</h3>
            </div>
          </div>

          <div class="col-md-4 col-sm-12">

              <div class="quest-text1 wow animated slideInLeft">
                <div class="img-hover9"></div>
                <p
                  class="line"
                >The Discovr team has been a great pleasure to work with - always responsive to my many queries and requests, as well as coming up with realistic suggestions on how we analyse/visualise our data.</p>
                <hr class="border-hr" />
                <img
                  src="../image/client-logos/ResetHealthLogo.png"
                  class="img-testimonial"
                  alt="testimonial"
                />
                <h5>
                  <a href="#">Dr Ling C | Head of Operations, Reset Health</a>
                </h5>

              </div>

          </div>
          <div class="col-md-4 col-sm-12">
            <router-link
              to="/Case-Study/Machine%20Learning%20for%20WorkPlace%20Buzz?post_id=439vIex7RTKByrUfH5v3H0"
            >
              <div class="quest-text1 wow animated slideInUp">
                <div class="img-hover9"></div>
                <p
                  class="line"
                >Discovr Analytics has helped us to modernise our Engagement Survey Product's infrastructure allowing us to gain much more valuable insights for us and our customers.</p>
                <hr class="border-hr" />
                <img
                  src="../image/client-logos/WPB-logo.png"
                  class="img-testimonial"
                  alt="testimonial"
                />
                <h5>
                  <a href="#">Mark S PhD | Chief Psychologist, WorkplaceBuzz</a>
                </h5>
                <a>
                  <br />Read Case Study
                </a>
              </div>
            </router-link>
          </div>
          <div class="col-md-4 col-sm-12">
            <router-link
              to="/Case-Study/eDNA%20OTA%20and%20Meta%20Analysis%20for%20EasyJet?post_id=5Yix0Lb8ZNtYcIIPvWNHKd"
            >
              <div class="quest-text1 wow animated slideInRight">
                <div class="img-hover9"></div>
                <p
                  class="line"
                >Discovr Analytics helped us develop and manage intuitive analytics for our customers - all hosted in their easy to use white-label business intelligence platform.</p>
                <hr class="border-hr" />
                <img
                  src="../image/client-logos/edna-logo.png"
                  class="img-testimonial"
                  alt="testimonial"
                />
                <h5>
                  <a href="#">Jon S | Founder and Director, eDNA Solutions</a>
                </h5>
                <a>
                  <br />Read Case Study
                </a>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Data Management",
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "Tailored Data Management Consulting & Development; We design and develop analytics for small to medium sized business and enterprise clients using tools like Google BigQuery, PostgreSQL and Elasticsearch."
      }
    ],
    htmlAttrs: {
      lang: "en"
    },
    title: "Discovr Analytics | Analytics Consulting & Development Company",
    // override the parent template and just use the above title only
    titleTemplate: null
  },
  data: function() {
    return {
      scrolled: true
    };
  },
  beforeDestroy() {
    window.analytics.page("Data Management");
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
